export const dataSafety = {
  title: 'Keeping your log safe',
  intro:
    'Everything you log lives on this phone. Two things keep it safe: letting the browser protect it, and saving a backup file you keep yourself.',

  protectedOn: 'Protected storage is on',
  protectedOnBody:
    'Your browser has been asked not to clear this app to free up space.',
  protectedOff: 'Protected storage is off',
  protectedOffBody:
    'Your browser may clear this app if the phone runs low on space. Turning this on makes that much less likely.',
  protectButton: 'Turn on protected storage',
  protectDeclined:
    'Your browser did not grant it yet. Adding the app to your home screen and using it for a few days usually convinces it.',

  exportButton: 'Save a backup file',
  exporting: 'Preparing…',
  exportHint:
    'A single file with every feeding, diaper, and weight. Keep it in Files, iCloud, or Google Drive.',
  exportShared: (n: number) => `Backup ready with ${n} ${n === 1 ? 'entry' : 'entries'}.`,
  exportDownloaded: (n: number) =>
    `Backup saved with ${n} ${n === 1 ? 'entry' : 'entries'}. Check your downloads.`,
  exportFailed: 'Could not create the backup file. Please try again.',

  importButton: 'Restore from a backup',
  importing: 'Restoring…',
  importHint:
    'Bring a backup onto this phone. Nothing already here is lost: newer entries always win.',
  importDone: (added: number, updated: number) =>
    updated > 0
      ? `Restored ${added} new ${added === 1 ? 'entry' : 'entries'} and updated ${updated}.`
      : `Restored ${added} ${added === 1 ? 'entry' : 'entries'}.`,
  importNothingNew: 'That backup was already up to date. Nothing changed.',
  importBadFile: 'That does not look like a First Weeks backup file.',
  importFailed: 'Could not read that file. Please try again.',

  clearWarning:
    'One thing to know: if you clear your browser data or delete the app, this log goes with it. A backup file is the only way to get it back.',
  usage: (size: string, date: string) => `Using ${size} as of ${date}.`,
};
